var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"v-button",class:{
    'v-button-active': !this.disabled,
    'v-button-disabled': this.disabled,
    'v-button-warning': this.type === 'warning',
    'v-button-primary': this.type === 'primary',
    'v-button-remind': this.type === 'remind',
  },attrs:{"role":"button"},on:{"click":_vm.click}},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }